/** @jsxImportSource @emotion/react */
import { Autocomplete, Button, DialogActions, DialogContent, Divider, FormControl, FormHelperText, Grid, IconButton, InputAdornment, Snackbar, ToggleButton, ToggleButtonGroup, Typography, useTheme, Tabs, Tab, CircularProgress } from '@mui/material';
import { useFormik } from 'formik';
import { useContext, useRef, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import * as yup from 'yup';
import { useEffect } from 'react';
import { StyledTextField } from '../../Components/CustomTextfield';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import IFSCFinder from './IFSCFinder';
import UploadIcon from "../../Components/DocumentUpload/UploadIcon"
import DialogForUpload from "../../Components/DocumentUpload/DialogForUpload"
import UploadDialog from "../../Components/DocumentUpload/UploadDialog"
import UploadPdf from "../../Components/DocumentUpload/UploadPdf"
import ProofDialog from "../../Components/DocumentUpload/ProofDialog"
import FullScreenLoader from '../../Components/FullScreenLoader';
import { useNavigate } from 'react-router-dom';
import { detailChecker, steps, getGlobalSteper } from '../../Helper/AppStepperData';
import { updateStepper } from '../../Helper/Redux/reducers/upDown';
import { getObjections, objectionNavigation, setObjections } from '../../Helper/Functions';
import Upload from '../../Components/Upload';
import EditIcon from '@mui/icons-material/Edit';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
function BankDetails(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [snackBarOpen, setSnackBarOpen] = useState(false)
    const [responseStatus, setResponseStatus] = useState({})
    const [openIMPSFailedPopup, setOpenIMPSFailedPopup] = useState(false)
    const [openIMPSSuccessPopup, setOpenIMPSSuccessPopup] = useState(false)
    const [showIFSCFinder, setShowIFSCFinder] = useState(false)
    const [IFSCCodes, setIFSCCodes] = useState([])
    const [selectedBank, setSelectedBank] = useState()
    const [isCancelledCheque, setIsCancelledCheque] = useState(false)
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState();
    const [open, setOpen] = useState(false);
    const [objectionState, setObjectionState] = useState({"isObjection" : false, "objections" : []})

    const [documentsUploadedDetails, setDocumentsUploadedDetails] = useState([])
    const [documentOf, setDocumentOf] = useState()
    const [documentOfScreen, setDocumentOfScreen] = useState()
    const [openInnerDialog, setOpenInnerDialog] = useState(false);
    const [documentTypeOption, setDocumentTypeOption] = useState();
    const [documentUploadedFor, setDocumentUploadedFor] = useState();
    const [showUploadPopup, setUploadPopup] = useState(false);
    const [image, setImage] = useState();
    const [pdf, setPdf] = useState();
    const [showPdfPopup, setPdfPopup] = useState(false);
    const [docMId, setDocMId] = useState()
    const [numberOfImages, setNumberOfImages] = useState(1)
    const [documentName, setDocumentName] = useState("");
    const [documentMappingKey, setDocumentMappingKey] = useState("");
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [disableAllFields, setDisableAllFields] = useState(false);
    const [value, setValue] = useState();
    const [fetchedBankData, setFetchedBankData] = useState(false);
    const [successQRPopUp, setSuccessQRPopUp] = useState({ popup: false, tabValue: 0 })
    const [qrCodeData, setQRCodeData] = useState(null);

    const localeText = useContext(Il8nContext)
    const intervalRef = useRef(null);
    const qrCalledRef = useRef(false);
    const documentTypePerName = {
        "CPOA": "Corresponding Address",
        "PPOA": "Permanent Address",
        "POA": "Power of Attorney",
        "POI": "Proof Of Identity",
        "Sign": "Signature",
        "Photo": "Photograph",
        "KYCP": "KYC Proof",
        "DePr": "Demat Proof",
        "BaPr": "Bank Proof",
        "InPr": "Income Proof",
        "Nom": "Nominee Proof",
        "Gurd": "Guardian Proof",
        "IPV": "In-Person Verification",
        "KRA": "KYC KRA Page",
        "default": "Document Upload",
        "BalSh": "Copy of Balance sheet of past two years",
        "AuSig": "Authorised Signatory on letter head of Firm/Company",
        "ITR": "IT Return for last 2 financial years",
        "PDeed": "Partnership  deed",
        "PCapR": "Partnership capital ratio",
        "DMapL": "Demat account Mapping Letter",
        "MOA": "MOA and AOA of the company",
        "Annx": "Annexure page",
        "BoRes": "Board Resolution",
        "NetWo": "Net Worth Certificate",
        "RCert": "Registration Certificate",
        "Oth": "Others",
    }

    const documentICONS = {
        "CPOA": "/images/Address Proof.svg",
        "PPOA": "/images/Address Proof.svg",
        "POI": "/images/Photo ID Proof.svg",
        "Sign": "/images/Signature.svg",
        "Photo": "/images/Photo.svg",
        "BaPr": "/images/Bank-Proof.svg",
        "IPV": "/images/IPV (Video Recording).svg",
        "Oth": "/images/Signature.svg"
    }
    
    useEffect(() => {
        getStageDetails()   
        getBankDetails()
        let objectionValue = getObjections()
        let objections = objectionValue?.filter(objection=>objection.navigationPath == "/BankDetails")
            
        if(objections?.length>0){
            objections = objections.map(objection => { 
                return {
                    "objectionDescription" : objection.objectionDescription, 
                    "remark": objection.remark
                }
            })

            objectionValue = objectionValue.map(objection=> { 
                if(objection.navigationPath == "/BankDetails"){
                    objection.isNavigationDone = true; 
                }
                return objection 
            })

            setObjections(objectionValue)
            setObjectionState({ isObjection : true, objections })
        }

    }, [])

    const handleChange = (event, newValue) => {
        if(newValue === 0 ){
            getBankVerificationQR(newValue)
        }
        setValue(newValue);
        if (intervalRef.current && newValue == 1) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const getBankVerificationQR = (tabValue) => {
        setLoading(true)
        setQRCodeData(null)
        const payload = { product: 'DIY' };
        axios.post(process.env.REACT_APP_API_URL + config.bankVerificationQR, payload)
            .then(resp => {
                if (resp?.data?.success) {
                    setQRCodeData(resp?.data?.success)
                    if (!intervalRef.current) {
                        intervalRef.current = setInterval(() => {
                            getRecursiveBankDetail(tabValue);
                        }, 3000);
                    }
                    setLoading(false)
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                    if(detailChecker(resp.data.success.stageDetilasList, 4)){
                        getBankDetails();
                    }
                    else{
                        setLoading(false)
                    }
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

     const getBankDetails = () => {
        !qrCalledRef.current && setLoading(true);
        axios.get(process.env.REACT_APP_API_URL + config.getBankDetails)
            .then(response => {
                const data = response?.data;
                if (data?.success && Array.isArray(data?.success) && data?.success?.length > 0) {
                    setFetchedBankData(true)
                    setLoading(false);
                    setDisableAllFields(true)
                    setValue(1);
                    const values = data.success[0];
                    setUploadedDocuments(values.kycFormProofUpload);
                    setDocumentsUploadedDetails(values.kycFormProofUpload.map(doc => ({ documentOf: doc.documentTypeCode, proofId: doc.kycstgProofId })));
                    setIsCancelledCheque(values.bankVerifiedImps === "N");
                    formik.setValues({
                        ifscCode: values.bankIfsccode,
                        bankName: values.bankName,
                        bankBranchName: values.bankBranch,
                        accountNumber: values.bankAccountNo,
                        confirmAccountNumber: values.bankAccountNo,
                        micrCode: values.bankMicrcode,
                        accountType: values.bankAccountType
                    })
                } else {
                    setLoading(false);
                    setValue(0);
                    if (!qrCalledRef.current) {
                        getBankVerificationQR(0);
                        qrCalledRef.current = true;
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                setResponseStatus({ message: error.message, type: 'error' });
                setSnackBarOpen(true);
            });
    };

    const getRecursiveBankDetail = (tabValue) => {
        axios.get(process.env.REACT_APP_API_URL + config.getBankDetails)
            .then(response => {
                const data = response?.data;
                if (data?.success && Array.isArray(data?.success) && data?.success?.length > 0) {
                    setFetchedBankData(true)
                    if (data?.success[0]?.bankVerifiedImps === "N") {
                        setValue(1);
                        setDisableAllFields(true)
                        setUploadedDocuments(data?.success[0]?.kycFormProofUpload);
                        setDocumentsUploadedDetails(data?.success[0]?.kycFormProofUpload.map(doc => ({ documentOf: doc.documentTypeCode, proofId: doc.kycstgProofId })));
                        setIsCancelledCheque(data?.success[0]?.bankVerifiedImps === "N");
                        formik.setValues({
                            ifscCode: data?.success[0]?.bankIfsccode,
                            bankName: data?.success[0]?.bankName,
                            bankBranchName: data?.success[0]?.bankBranch,
                            accountNumber: data?.success[0]?.bankAccountNo,
                            confirmAccountNumber: data?.success[0]?.bankAccountNo,
                            micrCode: data?.success[0]?.bankMicrcode,
                            accountType: data?.success[0]?.bankAccountType,
                        });
                    } else {
                        setSuccessQRPopUp({ popup:true, tabValue: 0})
                    }
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                }
            })
            .catch(error => {
                setResponseStatus({ message: error.message, type: 'error' });
                setSnackBarOpen(true);
            });
    };

    function toogleInnerDialog() {
        setOpenInnerDialog(!openInnerDialog);
    }

    var getDocumentTypeOptions = (documentTypeCode, documentUploadedForValue, documentOfValue, screenOf) => {
        setDocumentTypeOption(documentTypeCode)
        setOpenInnerDialog(!openInnerDialog)
        setDocumentUploadedFor(documentUploadedForValue)
        setDocumentOf(documentOfValue)
        setDocumentOfScreen(screenOf)
    }

    const onFile = (prm, docId, count, name, mappingKey) => {
        prm.then(succ => {
            toogleInnerDialog()
            if (succ.type.includes("pdf")) {
                setPdf(succ)
                setPdfPopup(true)
            }
            else {
                setImage([succ.data])
                setUploadPopup(true)
            }
            setDocMId(docId)
            setNumberOfImages(count)
            setDocumentName(name)
            setDocumentMappingKey(mappingKey)
        })
    }

    var uploadDocument = (documentData) => {
        setLoading(true)
        let documentArr = [...documentsUploadedDetails];
        let count = 0;
        documentData.forEach(document => {
            axios.post(`${process.env.REACT_APP_API_URL}${config.uploadDocument}`, document)
                .then(response => {
                    count++;
                    setLoading(false)
                    if (response.data.success) {
                        var docNotUploaded = response.data.success.find(docResponse => docResponse.Status == false)

                        if (docNotUploaded) {
                            setResponseStatus({ "message": `${"Unable to upload document "}${docNotUploaded.uploadId}`, "type": "error" })
                            setSnackBarOpen(true)
                        }
                        else {
                            if (documentTypeOption.toLowerCase().includes("nom")) {
                                // store.dispatch(change("nomineeDetails", "nomineeIdentification"+currentDocumentIndex, documentMappingKey))
                                // store.dispatch(change("nomineeDetails", "nomineeIdentificationDetails"+currentDocumentIndex, ""))
                            }
                            else if (documentTypeOption.toLowerCase().includes("gurd")) {
                                // store.dispatch(change("nomineeDetails", "guardianIdentification"+currentDocumentIndex, documentMappingKey))
                                // store.dispatch(change("nomineeDetails", "guardianIdentificationDetails"+currentDocumentIndex, ""))
                            }
                            setResponseStatus({ "message": "Documents Uploaded Successfully", "type": "success" })
                            setSnackBarOpen(true)
                            documentArr = [...documentArr, {
                                "documentTypeCode": document.docTypeCode,
                                "proofId": response.data.success[0].id,
                                "documentOf": documentOf,
                                "documentScreen": documentOfScreen
                            }]
                            count == documentData.length && setDocumentsUploadedDetails(documentArr)
                        }
                    }
                    if (response.data.error) {
                        setResponseStatus({ "message": response.data.error, "type": "error" })
                        setSnackBarOpen(true)
                    }
                })
                .catch(exception => {
                    setLoading(false)
                    setResponseStatus({ "message": exception.message, "type": "error" })
                    setSnackBarOpen(true)
                })
        })
    }

    const uploadImageProof = (data) => {
        if (data && data.length > 0) {
            var outData = data.map((dt, i) => dt && ({
                "pageNo": (i + 1),
                "pan": "", // pendingFormDetails ? pendingFormDetails.PanNo : (formValueSelector("accountDetails")(store.getState(0), "specialSegment")=="isDPOnly" && isMinorByDateSelected()) ? clientData.panNumber || formValueSelector("panCriteria")(store.getState(0), "panNumber") : formValueSelector("panCriteria")(store.getState(0), "panNumber"),
                "uploadId": (i + 1),
                "docTypeCode": documentTypeOption,
                "docMId": docMId,
                "type": documentUploadedFor,
                // "latitude": /* documentTypeOption == "Photo" ? geoLocationData.latitude : */ "",
                // "longitude": /* documentTypeOption == "Photo" ? geoLocationData.longitude : */ "",
                "objectionId": "",
                "fileType": dt.split(",")[0].split("/")[1].split(";")[0],
                "product": "diy",
                "base64Format": dt.split(",")[1]
            }))
            uploadDocument(outData)
        }
        setUploadPopup(false)

    }

    const uploadPdfProof = (pdfData, pdfName) => {
        setPdfPopup(false)
        var outData = [{
            "pageNo": "1",
            "pan": "", // pendingFormDetails ? pendingFormDetails.PanNo : (formValueSelector("accountDetails")(store.getState(0), "specialSegment")=="isDPOnly" && isMinorByDateSelected()) ? clientData.panNumber || formValueSelector("panCriteria")(store.getState(0), "panNumber") : formValueSelector("panCriteria")(store.getState(0), "panNumber"),
            "uploadId": "1",
            "docTypeCode": documentTypeOption,
            "docMId": docMId,
            "type": documentUploadedFor,
            // "latitude": /* documentTypeOption == "Photo" ? geoLocationData.latitude : */ "",
            // "longitude": /* documentTypeOption == "Photo" ? geoLocationData.longitude : */ "",
            "objectionId": "",
            "fileType": "pdf",
            "product": "diy",
            "base64Format": pdfData && pdfData.split(",")[1]
        }]
        if (pdfData !== null) {
            uploadDocument(outData)
        }
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const toggleIMPSFailedPopup = () => {
        setOpenIMPSFailedPopup(!openIMPSFailedPopup)
    }

    const toggleIMPSSuccessPopup = () => {
        setOpenIMPSSuccessPopup(!openIMPSSuccessPopup)
    }

    const handleIMPSVerification = () => {
        toggleIMPSFailedPopup()
        submitBankDetails(formik.values)
    }

    const nextNavigation = ()=>{
        if (isCancelledCheque && !uploadedDocuments.find(upload => upload.documentTypeCode) ) {
            setResponseStatus({ "message": "Document Upload Mandatory", "type": "error" })
            setSnackBarOpen(true)
            return
        }
        if(objectionState.isObjection){
            objectionNavigation(navigate)
        }
        else{
            dispatch(updateStepper({ step: 3, nestedStep: 1 }));
            navigate("/PlanDetails")
        }
    }

    const handleIMPSSuccessfulVerification = () => {
        toggleIMPSSuccessPopup()
        nextNavigation()
    }

    const submitBankDetails = (values) => {
        if (isCancelledCheque && !uploadedDocuments.find(upload => upload.documentTypeCode) ) {
            setResponseStatus({ "message": "Document Upload Mandatory", "type": "error" })
            setSnackBarOpen(true)
            return
        }
        setLoading(true)
        let obj = {
            "bankBranch": values.bankBranchName,
            "bankAccountNo": values.accountNumber,
            "bankName": values.bankName,
            "bankMicrcode": values.micrCode || "",
            "bankAddress1": selectedBank?.bankAddress1 || "",
            "bankAddress2": selectedBank?.bankAddress2 || "",
            // "bankAddress3": selectedBank?.bankAddress3 || "",
            "bankId": selectedBank?.bankId,
            "bankAccountType": values.accountType,
            "bankIfsccode": values.ifscCode,
            "bankState": selectedBank?.state,
            "bankCity": selectedBank?.city,
            "isCancelCheque": isCancelledCheque
        }
        axios.post(process.env.REACT_APP_API_URL + config.bankDetails, obj).then(resp => {
            setLoading(false)
            if (resp.data.success) {
                if (resp.data.name_matched) {
                    // window.open(`${window.location.origin}${"/BrokerageDetails"}`, "_self")
                    toggleIMPSSuccessPopup()
                }
                else {
                    nextNavigation()
                }
            }
            else {
                resp.data.noOfAttempts==3 && setIsCancelledCheque(true)
                throw new Error(resp.data.error)
            }
        }).catch((error) => {
            setLoading(false)
            setResponseStatus({ "message": error.message, "type": "error" })
            setSnackBarOpen(true)
            // setIsCancelledCheque(true)
            toggleIMPSFailedPopup()
        })
    }

    const toggleIFSCFinder = () => {
        setShowIFSCFinder(!showIFSCFinder)
    }

    const handleQRSuccess = (tabValue) => {
        setSuccessQRPopUp({ popup:false ,tabValue: tabValue})
        if (tabValue === 0) {
            nextNavigation();
        }
    }

    const validationSchema = yup.object({
        ifscCode: yup
            .string('')
            .required(localeText?.bankDetailsIFSCCodeRequired),
        bankName: yup
            .string('')
            .required(localeText?.bankDetailsBankNameRequired),
        bankBranchName: yup
            .string('')
            .required(localeText?.bankDetailsBankBranchNameRequired),
        accountNumber: yup
            .string('')
            .nullable()
            .required(localeText?.bankDetailsAccNumRequired),
        confirmAccountNumber: yup
            .string('')
            .nullable()
            .required(localeText?.bankDetailsConfAccNumRequired)
            .oneOf([yup.ref('accountNumber'), null], localeText?.bankDetailsAccNumMustMatch),
        micrCode: yup
            .string('')
            .required(localeText?.bankDetailsMICRCodeRequired),
        accountType: yup
            .string('')
            .required(localeText?.bankDetailsAccTypeRequired)
            .nullable()
    });

    const formik = useFormik({
        initialValues: {
            ifscCode: '',
            bankName: "",
            bankBranchName: "",
            accountNumber: "",
            confirmAccountNumber: "",
            micrCode: "",
            accountType: ""
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            submitBankDetails(values)
        },
    });

    const setBankFields = (values, closeIFSCFinder) => {
        formik.setFieldValue("ifscCode", values.ifsccode)
        formik.setFieldValue("bankName", values.bankName)
        formik.setFieldValue("bankBranchName", values.bankBranch)
        formik.setFieldValue("micrCode", values.micrcode)
        formik.setFieldValue("accountNumber", "")
        formik.setFieldValue("confirmAccountNumber", "")
        setSelectedBank(values)
        closeIFSCFinder && toggleIFSCFinder()
        setOpen(false)
        setIFSCCodes([])
    }

    let timer;
    const handleIFSCSearch = (e) => {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => callSearchAPI(e), 1000)
    }

    const callSearchAPI = (e)=>{
        setIFSCCodes([])
        let dataObj = {
            key: e.target.value,
            type: "ifscCode"
        }
        axios.post(process.env.REACT_APP_API_URL + config.search, dataObj)
            .then(resp => {
                if (resp.data.success) {
                    setIFSCCodes(resp.data.success)
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((error) => {
                setResponseStatus({ "message": error.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const getOptionComponent = (searchedItem,index,closeIFSCFinder)=>{
        return <Grid item  css={{ width: "100%", padding: "20px", borderTop: index !=0 ? "1px solid grey":'' }} onClick={() => setBankFields(searchedItem, closeIFSCFinder)}>
            <Typography variant='body1' css={{ fontWeight: "bold" }}>
                {searchedItem.ifsccode}
            </Typography>
            <img src="images/Next-page-btm.svg" alt="select" css={{ float: "right" }} />
            <Typography variant='body2'>
                {searchedItem.bankName}
            </Typography>
            <Typography variant='body2'>
                {searchedItem.bankBranch}
            </Typography>
            <Typography variant='body2'>
                {searchedItem.bankAddress1}
            </Typography>
        </Grid>
    }
    console.log("Formik Values", formik?.values);
    console.log("Formik Errors", formik?.errors);

    return (
        <>
            {showIFSCFinder ?
                <IFSCFinder getOptionComponent={getOptionComponent} toggleIFSCFinder={toggleIFSCFinder} setBankFields={setBankFields} setResponseStatus={setResponseStatus} setSnackBarOpen={setSnackBarOpen}/>
                :
                <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
                    <PageLayout css={{ overflowY: "scroll" }} showSidebar isObjectionScreen={objectionState.isObjection}
                        breadcrumb={{ show: true, steps: steps[2].nestedSteps, step: 3, nestedStep: 1 }}>
                        <ElevatedGrid >
                            <Grid container item alignItems={"start"} spacing={3}>
                                <Grid container item alignItems={"center"}>
                                    {objectionState.isObjection && <Grid item xs={12} css={{ padding: "10px", color: "white", backgroundColor: "lightcoral", borderRadius: "10px", margin: "10px 0px" }}>
                                        {objectionState.objections.map((objection, i) =>
                                            <>
                                                <Typography align="center" display="inline" variant="body2" fontWeight={"bold"}>
                                                    {localeText?.profileObjection} {objection.objectionDescription || "--"} {localeText?.profileObjectionRemark} {objection.remark || "--"} <br />
                                                </Typography>
                                                {i > 0 && <Divider />}
                                            </>
                                        )}
                                    </Grid>}
                                    <Grid item xs={12} css={{ display:'flex',justifyContent:'space-between' }}>
                                        <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                            {localeText?.bankDetailsTitle}
                                        </Typography>
                                        {<IconButton
                                            aria-label="close"
                                            onClick={()=>setDisableAllFields(!disableAllFields)}
                                            size="large"
                                            disabled={!objectionState.isObjection}
                                            >
                                            <EditIcon />
                                        </IconButton>}
                                    </Grid>
                                </Grid>

                                <Grid container item xs={12} md={12} lg={12}>
                                    <Tabs value={value} onChange={handleChange} aria-label="disabled tabs example">
                                        <Tab label="QR" disabled={fetchedBankData} />
                                        <Tab label="Manual" />
                                    </Tabs>
                                </Grid>
                                {value === 0 && (
                                    <Grid container item xs={12} md={12} lg={12} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                                        { qrCodeData ? (
                                            <><h2>{localeText?.bankDetailsQRTitle}</h2>
                                                <div>
                                                    <img src={"data:application/image/png;base64," + qrCodeData} />
                                                    </div>
                                                    <div style={{ display:'flex', flexDirection:'row',justifyContent:'center',alignItems:'center',margin:'30px 0 30px' }}>
                                                        <div className="p-4" style={{
                                                            position: "relative",
                                                            marginRight: '55px'
                                                        }}>
                                                            <div className="p-6 rounded-xl" style={{
                                                                position: "absolute",
                                                                top: "-30px",
                                                                left: "-8px"
                                                            }}>
                                                                <CurrencyRupeeIcon sx={{ fontSize: 48, color: '#2563EB', zIndex: 10 }} />
                                                                <CircularProgress
                                                                    size={65}
                                                                    thickness={4}
                                                                    sx={{
                                                                        color: '#24b7cc',
                                                                        display: 'block',
                                                                        position: 'absolute',
                                                                        top: '-6px',
                                                                        left: '-10px',
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <Typography variant="body2" style={{ color:'red' }}>{localeText?.bankDetailsProcessingTitle}</Typography>
                                                    </div>
                                                </>
                                        ) : null}
                                    </Grid>
                                )}
                                {value === 1 && (
                                    <>
                                <Grid container item xs={12} md={12} lg={8} spacing="12" css={{ marginTop: "5px" }}>
                                    <Grid item xs={12} md={6}>
                                        <Autocomplete
                                            css={{ marginTop: "10px" }}
                                            id="ifscCode" name="ifscCode"
                                            value={formik.values.ifscCode}
                                            open={open}
                                            autoComplete="chrome-off"
                                            disabled={disableAllFields}
                                            onOpen={() => {
                                                setOpen(true);
                                            }}
                                            onClose={() => {
                                                setOpen(false);
                                            }}
                                            options={IFSCCodes}
                                            disablePortal
                                            filterOptions={(x) => x} 
                                            loading={open && IFSCCodes.length==0}
                                            renderOption={(props, searchedItem, state)=>{
                                                return getOptionComponent(searchedItem)
                                            }}
                                            isOptionEqualToValue={(option, value) => { return option.ifsccode === value }}
                                            getOptionLabel={(option) => { return option }}
                                            renderInput={(params) => <StyledTextField {...params} fullWidth variant="outlined" label={localeText?.bankDetailsIFSCCode}
                                                onChange={handleIFSCSearch}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                size="small"
                                                id="ifscCode" name="ifscCode"
                                                error={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)}
                                                helperText={formik.touched.ifscCode && formik.errors.ifscCode}
                                                auto
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: <InputAdornment position="end">
                                                        {disableAllFields ? (
                                                            <Typography variant="body2" color="textSecondary" css={{ textDecoration: "none", cursor: "default", fontStyle: "italic" }}>
                                                                {localeText?.bankDetailsFindIFSCCode}
                                                            </Typography>
                                                        ) : (
                                                            <Typography variant="body2" color="primary" onClick={toggleIFSCFinder} css={{ textDecoration: "underline", cursor: "pointer", fontStyle: "italic" }}>
                                                                {localeText?.bankDetailsFindIFSCCode}
                                                            </Typography>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </InputAdornment>
                                                }}
                                            />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <StyledTextField id="bankName" name="bankName" css={{ marginTop: "10px" }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                            value={formik.values.bankName}
                                            error={formik.touched.bankName && Boolean(formik.errors.bankName)}
                                            helperText={formik.touched.bankName && formik.errors.bankName} fullWidth
                                            label={localeText?.bankDetailsBankName} variant="outlined"
                                            onChange={formik.handleChange}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <StyledTextField id="bankBranchName" name="bankBranchName" css={{ marginTop: "10px" }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                            value={formik.values.bankBranchName}
                                            error={formik.touched.bankBranchName && Boolean(formik.errors.bankBranchName)}
                                            helperText={formik.touched.bankBranchName && formik.errors.bankBranchName} fullWidth
                                            label={localeText?.bankDetailsBankBranchName} variant="outlined"
                                            onChange={formik.handleChange}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <StyledTextField id="micrCode" name="micrCode" css={{ marginTop: "10px" }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                            value={formik.values.micrCode}
                                            error={formik.touched.micrCode && Boolean(formik.errors.micrCode)}
                                            helperText={formik.touched.micrCode && formik.errors.micrCode} fullWidth
                                            label={localeText?.bankDetailsMICRCode} variant="outlined"
                                            onChange={formik.handleChange}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <StyledTextField id="accountNumber" name="accountNumber" css={{ marginTop: "10px" }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                            value={formik.values.accountNumber}
                                            error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
                                            type="password"
                                            helperText={formik.touched.accountNumber && formik.errors.accountNumber} fullWidth
                                            label={localeText?.bankDetailsAccNum} variant="outlined"
                                            onChange={formik.handleChange}
                                            disabled={disableAllFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <StyledTextField id="confirmAccountNumber" name="confirmAccountNumber" css={{ marginTop: "10px" }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                            value={formik.values.confirmAccountNumber}
                                            error={formik.touched.confirmAccountNumber && Boolean(formik.errors.confirmAccountNumber)}
                                            helperText={formik.touched.confirmAccountNumber && formik.errors.confirmAccountNumber} fullWidth
                                            label={localeText?.bankDetailsConfAccNum} variant="outlined"
                                            onChange={formik.handleChange}
                                            disabled={disableAllFields}
                                        />
                                    </Grid>
                                    <Grid container item xs={12} css={{ marginTop: "10px" }}>
                                        <Grid item xs={12}>
                                            <Typography css={{ textTransform: "none", fontWeight: "bold" }}>
                                                {localeText?.bankDetailsAccType}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl required error={formik.touched.accountType && Boolean(formik.errors.accountType)} css={{ marginTop: "10px" }}>
                                                <ToggleButtonGroup
                                                    value={formik.values.accountType}
                                                    exclusive
                                                    id="accountType"
                                                    name="accountType"
                                                    onChange={(e, value) => { formik.setFieldValue("accountType", value) }}
                                                    color="primary"
                                                >
                                                    <ToggleButton value="Current" css={{ textTransform: "none" }}>
                                                    {localeText?.bankDetailsAccCurr}
                                                    </ToggleButton>
                                                    <ToggleButton value="Savings" css={{ textTransform: "none" }}>
                                                    {localeText?.bankDetailsAccSav}
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                                <FormHelperText>{formik.touched.accountType && formik.errors.accountType}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} css={{ margin: "20px 0" }}>
                                        <Button type="submit" variant='contained' disabled={isCancelledCheque || disableAllFields} color="primary">
                                            {localeText?.bankDetailsVerifyBank}
                                        </Button>
                                    </Grid>
                                    {isCancelledCheque ?
                                        <>
                                            <Grid item xs={12}>
                                                <Upload
                                                    masterId={'4'}
                                                    title={localeText?.bankDetailsProof}
                                                    documentOptionData={{ id: "BaPr", type: "bank1", code: "BaPr", screen: "bankDetails" }}
                                                    setUploadedDocuments={(data) => 
                                                        {
                                                            if(data.length > 0){
                                                                setUploadedDocuments([ ...uploadedDocuments, ... data ])
                                                            }
                                                            else{
                                                                setUploadedDocuments([])
                                                            }

                                                        }
                                                    }
                                                    uploadedDocuments={uploadedDocuments?.filter(doc=> doc?.documentTypeCode =='BaPr')}
                                                    isRequired={true}
                                                    />
                                                {/* <UploadIcon
                                                    isSVG={true}
                                                    uploadDocument={() => getDocumentTypeOptions("BaPr", "bank1", "BaPr", "bankDetails")}
                                                    required={true}
                                                    uploaded={documentsUploadedDetails.find(holder => holder.documentOf == "BaPr" ? true : false)}
                                                    loading={false}
                                                    image={documentICONS["BaPr"]}
                                                    pgloading={false}
                                                    loader={null}
                                                    documentOf={false}
                                                >
                                                    {"Bank Proof"}
                                                </UploadIcon> */}
                                            </Grid>
                                            <Grid item xs={12} css={{ margin: "20px 0" }}>
                                                {!disableAllFields ? <Button variant='contained' color="primary" type="submit" >  {/* check if document has been uploaded */}
                                                    {localeText?.bankDetailsNextBtn}
                                                </Button> : <Button variant='contained' color="primary" onClick={() => nextNavigation()} >
                                                    {localeText?.bankDetailsNextBtn}
                                                </Button>}
                                            </Grid>
                                            </> : !objectionState.isObjection && <Grid item xs={12} css={{ margin: "20px 0" }}>
                                                    <Button variant='contained' color="primary" onClick={() => nextNavigation()} >
                                                        {localeText?.bankDetailsNextBtn}
                                                    </Button>
                                                </Grid>
                                    }
                                </Grid>

                                <Grid container item xs={12} md={12} lg={4}>
                                    <Grid item xs={12} css={{ marginTop: "5px", backgroundColor: "#E5F3FE", padding: "30px", borderRadius: "15px" }}>
                                        <Typography variant='body2'>
                                        {localeText?.bankDetailsGetRejected}
                                        </Typography>
                                        <br />
                                        <Typography variant='body2'>
                                        {localeText?.bankDetails3Attempts}
                                        </Typography>
                                        <br />
                                        <Typography variant='body2'>
                                            <b>{localeText?.bankDetailsNote}</b>
                                            <p>
                                            {localeText?.bankDetailsKindlyRecheck}
                                            </p>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                    </>
                                )}
                            </Grid>
                        </ElevatedGrid>
                    </PageLayout>
                </form>
            }

            {loading && <FullScreenLoader message={true}/>}

            {documentTypeOption && <ProofDialog setId={setId} onFile={onFile} getDocumentTypeURL={config.documentMaster + "4"} open={openInnerDialog} dialogTitle={documentTypePerName[documentTypeOption]}
                handleClose={toogleInnerDialog} data={documentTypeOption} />}
            {showUploadPopup &&
                <DialogForUpload open={showUploadPopup} handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={true} maxWidth='md'>
                    <UploadDialog
                        id={id}
                        multiple={numberOfImages} /// gives count to images to upload
                        handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                        title={documentName}
                        imageArray={image ? image : null}
                        count={numberOfImages}  /// gives count to images to upload
                        onSave={(data) => { uploadImageProof(data); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                    />
                </DialogForUpload>}
            {showPdfPopup &&
                <DialogForUpload open={showPdfPopup} handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={false} maxWidth='md'>
                    <UploadPdf
                        title={"Upload Pdf"}
                        file={pdf.data}
                        pdfName={pdf.name}
                        handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                        onUpload={(pdfData, pdfName) => { uploadPdfProof(pdfData, pdfName); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                    />
                </DialogForUpload>}

            <Popup
                open={openIMPSFailedPopup}
                maxWidth={"sm"}
            >
                <PopupTitle dontShowCloseIcon />
                <DialogContent css={{ textAlign: "center" }}>
                    <Grid container direction={"column"} alignItems={"center"} justifyContent="center">
                        <Grid item>
                            <img src="images/icon_Bank-IMPS-Failed.svg" alt="IMPS error" />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" css={{ fontWeight: "bold" }}>
                                {localeText?.bankDetailsBankIMPSFailed}
                            </Typography>
                        </Grid>
                        <Grid container item spacing={3} css={{ padding: "30px 0" }}>
                            <Grid item xs={12} md={6}>
                                <Button variant="contained" color="primary" css={{ textTransform: "none", minWidth: "max-content" }} onClick={()=>{toggleIMPSFailedPopup(); setIsCancelledCheque(true)}}>
                                {localeText?.bankDetailsUploadBankProof}
                                </Button>
                            </Grid>
                            {!isCancelledCheque && <Grid item xs={12} md={6}>
                                <Button variant="outlined" color="primary" css={{ textTransform: "none", minWidth: "max-content" }} onClick={handleIMPSVerification}>
                                {localeText?.bankDetailsReinitiateIMPS}
                                </Button>
                            </Grid>}
                        </Grid>
                    </Grid>
                </DialogContent>
            </Popup>

            <Popup
                open={openIMPSSuccessPopup}
                maxWidth={"sm"}
            >
                <PopupTitle dontShowCloseIcon />
                <DialogContent css={{ textAlign: "center" }}>
                    <Grid container direction={"column"} alignItems={"center"} justifyContent="center">
                        <Grid item>
                            <img src="images/icon_Bank-IMPS-Successful.svg" alt="IMPS success" />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" css={{ fontWeight: "bold" }}>
                                {localeText?.bankDetailsBankIMPSSuccessful}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} css={{ padding: "20px 0" }}>
                            <Button variant="outlined" color="primary" css={{ textTransform: "none" }} onClick={handleIMPSSuccessfulVerification}>
                            {localeText?.bankDetailsNextBtn}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Popup>
            {
                <Popup
                    open={successQRPopUp.popup}
                    maxWidth={"lg"}
                >
                    <PopupTitle dontShowCloseIcon customCSS={{ textAlign: "center",color:'#48B7CC',fontSize: '1.40rem',fontWeight:'700' }}>{localeText?.bankQrCodeSuccess}</PopupTitle>
                    <DialogContent>
                        <Typography variant='body2'>{localeText?.bankDetailsSuccessContent}</Typography>
                    </DialogContent>
                    <DialogActions style={{ display: "-webkit-box" }}>
                        <Button variant="contained" color="primary" onClick={() => handleQRSuccess(0)} style={{ float: 'right' }}>
                            {localeText?.bankDetailsOk}
                        </Button>
                    </DialogActions>
                </Popup>
            }

            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default BankDetails;
